import React, { useContext, useMemo } from "react";
import { CouponCallout } from "@vp/coupon-callout";
import { PageStaticDataContext } from "../../../contexts/PageStaticDataContextProvider";
import { ProductContext } from "../../../contexts/ProductContextProvider";

function CouponCalloutBuilder() {
  const { mpv } = useContext(PageStaticDataContext);
  const { selectedQuantity, selections } = useContext(ProductContext);

  return (
    <CouponCallout
      productId={mpv.coreProductId}
      version={mpv.version}
      quantity={selectedQuantity}
      selections={selections}
    />
  );
}

export default CouponCalloutBuilder;
